import React from 'react';
import { Link } from 'react-router-dom';

export default class Navigation extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            loading: true,
            navigationItems: []
        }
    }
    componentDidMount()
    {
        this.props.api.send({
            controller: "LMS",
            action: "GetNavigation",
            method: "get",
            success: (response) => {
                this.setState({navigationItems: response.navigationItems, loading: false});
            },
            error: (err) => {
                this.setState({loading: false});
            }
        })
    }
    render()
    {
        const navItems = this.state.navigationItems.map((item) => 
            <li key={item.label}><Link to={item.link} className={
                window.location.pathname === item.link ? "navactive" : null
            }>{item.label}</Link></li>
        );
        return (
            <div className="lmsnavigation">
            {this.state.loading ? (
                <div className="lmscenter">
                    <img src="/images/spinner.svg" alt="Loading..." />
                </div>
            ) : (
                <div>
                    <ul>
                        {navItems}
                    </ul>
                </div>
            )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/general/navigation.js